const DAYS_ES = [
    'domingo',
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sábado',
  ];
  
  const DEVICE_CHARGE_STATUS_ES = {
    CHARGING: null, // Charging
    NOT_CHARGING: null, // Not Charging
    FULLY_CHARGED: null, // Fully Charged
    default: '--',
  };
  
  const DEVICE_KINDS_ES = {
    battery: 'Batería',
    circuitBreaker: 'Disyuntor',
    ev: 'Vehículo Eléctrico',
    evse: 'Cargador de Vehículo Eléctrico',
    'evse-circuitBreaker': 'Disyuntor / Cargador de Vehículo Eléctrico',
    hwh: 'Calentador de agua',
    rac: null, // Room AC
    tstat: 'HVAC',
    v2g: null, // Vehicle to Grid
    pvsystem: 'Sistema PV',
    solarinv: 'Inversor Solar',
    default: 'desconocido', // Unknown
  };

  const EVENT_CATEGORY_ES = {
    pre: null, // Pre Event
    event: null, // Event
    post: null, // Post Event
    notification: null, // Notification
    recurring: null, // Recurring
    default: 'desconocido', // Unknown
  };
  
  const EVENT_INITIATOR_ES = {
    'platoon-event': null, //'Platoon Event
    schedule: null, // 'Schedule
    default: null, // Ad Hoc
  };
  
  const EVENT_TYPE_ES = {
    hwh: 'Calentador de agua',
    tstat: 'HVAC',
    battery: 'Batería',
    v2g: null, // Vehicle to Grid
    rac: null, // Room AC
    evse: 'Cargador de Vehículo Eléctrico',
    circuitBreaker: 'Disyuntor',
    'dr-event': null, // Event Notification
    'dr-ad-hoc': null, // Event Notification
    behavioral: null, // Behavioral Event
    email: null, // Ad Hoc Message
    default: 'desconocido', // Unknown
  };

  const MONTHS_ES = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ];
  
  const PAYMENT_TYPES_ES = {
    GIFT_CARD: null, // Gift Card
    default: 'desconocido', // Unknown
  };

  module.exports = Object.freeze({
    DAYS_ES,
    DEVICE_CHARGE_STATUS_ES,
    DEVICE_KINDS_ES,
    EVENT_CATEGORY_ES,
    EVENT_INITIATOR_ES,
    EVENT_TYPE_ES,
    MONTHS_ES,
    PAYMENT_TYPES_ES,
  });